import React, { useEffect, useState } from "react";
import { doc, setDoc } from "firebase/firestore";
import { useAuth, useFirestore, useFirestoreDocData } from "reactfire";

import questionData from "../data/questions";
import { Button, Card } from "react-bootstrap";
import { SDKButtonInterface } from "@loomhq/loom-sdk";
import IGame from "../interfaces/Game";
import { Auth } from "@firebase/auth";

export interface GameProps {
	documentId: string;
	loomButton?: SDKButtonInterface;
	gameData: IGame;
	auth: Auth;
}

const Game: React.FC<GameProps> = ({ documentId, loomButton, gameData, auth }) => {
	const [showQuestion, setShowQuestion] = useState(false);
	const [showCompleted, setShowCompleted] = useState(false);

	const firestore = useFirestore();
	const gameRef = doc(firestore, "games", documentId);

	useEffect(() => {
		setShowQuestion(true);
	}, []);

	const myStatus = gameData?.status?.[auth.currentUser?.uid ?? ""];
	const currentQuestion = myStatus?.questions.findIndex((q) => q.answer === undefined);

	const setAnswer = (index: number, optionId: number) => {
		setShowQuestion(false);
		gameData.status[auth.currentUser?.uid ?? ""].questions[index].answer = optionId;
		if (auth.currentUser?.uid && gameData?.status?.[auth.currentUser?.uid ?? ""].questions.every((q) => q.answer !== undefined)) {
			gameData.status[auth.currentUser.uid].completed = true;
		}
		setDoc(gameRef, gameData).then(() => {
			setTimeout(() => {
				setShowQuestion(true);
			}, 1000);
		});
	};

	useEffect(() => {
		if (gameData?.status?.[auth.currentUser?.uid ?? ""].completed) {
			setShowCompleted(true);
			if (loomButton) {
				loomButton.endRecording();
			}
		}
	}, [gameData]);

	return (
		<>
			{myStatus?.questions.map((question, qIndex) => {
				const qData = questionData.find((q) => q.id === question.questionId);
				if (!qData) {
					return null;
				}
				return (
					<div
						key={question.questionId}
						className={`question ${!!question.answer ? "answered" : ""} ${
							qIndex === currentQuestion && showQuestion ? "active" : ""
						}`}
					>
						<div className="question-text">
							<div className="deco">{qData.text}</div>
						</div>
						{qData.options.map((option, index, arr) => {
							const len = arr.length;
							return (
								<div
									key={option.id}
									className={`question-option option-${index} of-${len}`}
									onClick={() => {
										setAnswer(qIndex, option.id);
									}}
								>
									<div className="question-option-image-wrapper">
										<div className="question-option-image" style={{ backgroundImage: `url(${option.image})` }}></div>
									</div>
									<div className="question-option-text">{option.text}</div>
								</div>
							);
						})}
					</div>
				);
			})}
		</>
	);
};

export default Game;
